export const RELEVANCE = "relevance"
export const RECENT_MOST = "recent_most"
export const RECENT_LEAST = "recent_least"
export const SEEN_MOST = "seen_most"
export const SEEN_LEAST = "seen_least"
